<header class="bg-white border-b border-stone-100 sticky top-0 z-30">
  <div class="max-w-[1200px] mx-auto w-full pr-3 sm:pr-8 pl-16 md:pl-5 flex items-center justify-between gap-2 sm:gap-4" style="height: 4.5rem;">

    <!-- Left: Page title + Federation name -->
    <div class="flex-1 min-w-0">
      <h1 class="font-semibold text-base sm:text-lg truncate text-stone-800">{{ pageTitle }}</h1>
      @if (pageSubtitle) {
        <p class="text-xs text-stone-400 truncate">{{ pageSubtitle }}</p>
      }
    </div>

    <!-- Center: Federation logo -->
    <div class="hidden lg:flex absolute left-1/2 -translate-x-1/2 items-center justify-center pointer-events-none">
      <img src="assets/images/frmtt-logo.png" alt="{{ federationName }}"
        class="h-14 lg:h-16 w-auto object-contain"
        onerror="this.style.display='none'" />
    </div>

    <!-- Right: User + Logout -->
    <div class="flex items-center gap-2 sm:gap-3 flex-shrink-0">
      <span class="hidden sm:inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-600 border border-emerald-100">
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
        Actif
      </span>
      <div *ngIf="currentUser" class="flex items-center gap-2">
        <div class="w-8 h-8 rounded-full bg-stone-100 flex items-center justify-center">
          <span class="material-icons text-stone-500 text-sm">person</span>
        </div>
        <span class="text-sm font-medium text-stone-700 hidden sm:block">{{ currentUser.username }}</span>
      </div>
      <button
        (click)="logout()"
        aria-label="Déconnexion" class="inline-flex items-center justify-center gap-2 min-h-[36px] min-w-[36px] px-2.5 sm:px-3 py-1.5 bg-stone-100 hover:bg-stone-200 text-stone-700 hover:text-stone-900 rounded-lg font-medium text-xs transition-colors"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
        <span class="hidden sm:inline">Déconnexion</span>
      </button>
    </div>

  </div>
</header>
